import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class StepStatus extends Enum {
  static INVALID = {
    key: 'invalid',
    get value() {
      return Lang.t('guidancestep.not-applicable');
    }
  };

  static IN_PROGRESS = {
    key: 'in_progress',
    get value() {
      return Lang.t('estate.in-progress');
    }
  };

  static ON_HOLD = {
    key: 'on_hold',
    get value() {
      return Lang.t('guidancestep.on-hold');
    }
  };

  static TODO = {
    key: 'todo',
    get value() {
      return Lang.t('guidancestep.to-do');
    }
  };

  static SKIPPED = {
    key: 'skipped',
    get value() {
      return Lang.t('guidancestep.skipped');
    }
  };

  static PENDING = {
    key: 'pending',
    get value() {
      return Lang.t('asset.pending');
    }
  };

  static COMPLETED = {
    key: 'completed',
    get value() {
      return Lang.t('financialgateway.done');
    }
  };

  static UNDER_MAINTENANCE = {
    key: 'under_maintenance',
    get value() {
      return Lang.t('guidancestep.to-do');
    }
  };

  /**
   * @param key
   * @returns {boolean}
   */
  static isDone(key) {
    return key === StepStatus.COMPLETED.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isTodo(key) {
    return key === StepStatus.TODO.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isInvalid(key) {
    return key === StepStatus.INVALID.key;
  }

  /**
   * @param key
   * @returns {boolean}
   */
  static isUnderMaintenance(key) {
    return key === StepStatus.UNDER_MAINTENANCE.key;
  }

  /**
   * @returns {array}
   */
  static getDoneStatuses() {
    return [
      StepStatus.COMPLETED.key,
      StepStatus.PENDING.key,
      StepStatus.SKIPPED.key,
      StepStatus.INVALID.key
    ];
  }

  /**
   * @returns {array}
   */
  static getCompleteStatuses() {
    return [StepStatus.COMPLETED.key, StepStatus.PENDING.key, StepStatus.SKIPPED.key];
  }

  /**
   * @returns {array}
   */
  static getIncompleteStatuses() {
    return [StepStatus.TODO.key, StepStatus.IN_PROGRESS.key];
  }
}
